module.exports = __webpack_public_path__ + "static/punch-082b04609e5aa037af5b704d7dc4198f.gif";